import SideMenu from '@/containers/side-menu/SideMenu.vue';
import AtmMap from '@/pages/atm-map/AtmMap.vue';

export default {
  path: '/atm-map',
  name: 'AtmMap',
  components: {
    mainContent: AtmMap,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'login',
    },
  },
};
